export default __webpack_public_path__ + "3a088878fefea214c14aa1e1fb895311.svg";